import {ReviewStatus} from 'graphql-client/__generated/graphqlGlobalTypes';

import {
  getBadgeGating,
  getBadgeStatus,
  type ReviewBadgeGatingInput,
  type VersionScopedPanelContext,
  type VersionScopedReviewChange,
  type VisibleReviewBadgeDerivation,
} from './reviewBadgeShared';

/** Scopes review summary panel data for linear (non-versioned) reviewables. */
export function deriveLinearPanelContext<TChange extends VersionScopedReviewChange>({
  globalStatus,
  reviewChanges,
}: {
  globalStatus: ReviewStatus;
  reviewChanges: ReadonlyArray<TChange>;
}): VersionScopedPanelContext<TChange> {
  return {
    scopedReviewChanges: reviewChanges,
    scopedStatus: null,
    isActiveCycleVersion: true,
    panelStatus: globalStatus,
  };
}

/** Assembles linear review badge status, review status, and dropdown gating for the controller. */
export function deriveLinearReviewBadge(
  input: ReviewBadgeGatingInput & {reviewStatus?: ReviewStatus}
): VisibleReviewBadgeDerivation {
  const badgeStatus = getBadgeStatus(input.reviewStatus);
  return {
    isHidden: false,
    badgeStatus,
    reviewStatus: input.reviewStatus,
    ...getBadgeGating({
      enableReviewLifecycle: input.enableReviewLifecycle,
      canSendForReview: input.canSendForReview,
      parentReviewLifecycleCount: input.parentReviewLifecycleCount,
      reviewStatus: input.reviewStatus,
      reviewUsesReviewLifecycle: input.reviewUsesReviewLifecycle,
    }),
  };
}
